import { appStores, brand } from "../siteContent";
import { NavLink } from "./NavLink";

function StoreIcon({ platform }) {
  return platform === "Android" ? (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7 8h10a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-1V21a1 1 0 0 1-2 0v-2.5h-4V21a1 1 0 0 1-2 0v-2.5H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2Z" />
      <path d="m8 7-1.4-2M16 7l1.4-2M8.5 11.5h.01M15.5 11.5h.01" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <rect x="6" y="2" width="12" height="20" rx="3" />
      <path d="M10 5h4M10 19h4" />
    </svg>
  );
}

function DownloadLink({ store, className }) {
  return (
    <a
      className={`global-app-download-link ${className}`}
      href={store.url}
      target="_blank"
      rel="noreferrer"
      aria-label={`Download Aspirant CSS on ${store.storeName}`}
    >
      <StoreIcon platform={store.platform} />
      <span>
        <small>Download for {store.platform}</small>
        <strong>{store.storeName}</strong>
      </span>
      <b aria-hidden="true">↗</b>
    </a>
  );
}

export function AppDownloadCta({ navigate }) {
  return (
    <aside className="global-app-download" aria-labelledby="global-app-download-title">
      <div className="global-app-download-copy">
        <img src={brand.logo} alt="Aspirant CSS mobile app icon" width="58" height="58" loading="lazy" />
        <div>
          <span className="section-eyebrow">Study on mobile</span>
          <h2 id="global-app-download-title">Continue CSS and MPT preparation in the Aspirant app</h2>
          <p>
            Access structured lessons, solved CSS papers, past-paper MCQs, MPT mocks, vocabulary,
            current affairs and saved study progress on Android or iPhone.
          </p>
          <NavLink to="/aspirant-app" className="global-app-details-link" onNavigate={navigate}>
            Explore all app features <span aria-hidden="true">→</span>
          </NavLink>
        </div>
      </div>
      <div className="global-app-download-actions" aria-label="Download Aspirant CSS mobile app">
        <DownloadLink store={appStores.android} className="is-android" />
        <DownloadLink store={appStores.ios} className="is-ios" />
      </div>
    </aside>
  );
}
